"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeList = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const TimeItem_1 = require("./TimeItem");
const TimeList = ({ translatedKeyNoAvailableAppt, ariaLabelledBy, timeList, handleClick }) => {
    return (react_1.default.createElement(__1.TileGrid, { ariaLabelledBy: ariaLabelledBy, gridTemplateColumns: 'repeat(auto-fit, minmax(100px, max-content))' }, (timeList === null || timeList === void 0 ? void 0 : timeList.length) === 0
        ? react_1.default.createElement("p", { "data-testid": 'no-appt-message' }, translatedKeyNoAvailableAppt)
        : timeList.map((element) => react_1.default.createElement(TimeItem_1.TimeItem, { key: element, time: element, handleClick: handleClick }))));
};
exports.TimeList = TimeList;
